const FETCH_DISTRICTS = 'fetch_districts';
const FETCH_DISTRICTS_SIMPLY = 'fetch_districts_simply';
const FETCH_DISTRICT = 'fetch_district';
const DELETE_DISTRICT = 'delete_district';
const PERSIST_DISTRICT = 'persist_district';
const UPDATE_DISTRICT = 'update_district';

const CREATE_FILES_DISTRICT = 'staff_create_files_district';
const DELETE_FILE_DISTRICT = 'staff_delete_file_district';
const FETCH_FILES_DISTRICT = 'staff_fetch_files_district';

export default {
    FETCH_DISTRICTS,
    FETCH_DISTRICTS_SIMPLY,
    FETCH_DISTRICT,
    DELETE_DISTRICT,
    PERSIST_DISTRICT,
    UPDATE_DISTRICT,
    FETCH_FILES_DISTRICT,
    DELETE_FILE_DISTRICT,
    CREATE_FILES_DISTRICT,
};
